import {Component, computed, inject, OnInit, resource, ResourceRef} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {firstValueFrom, map, of} from "rxjs";
import { PageEvent, MatPaginatorModule } from "@angular/material/paginator";
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatButtonModule } from '@angular/material/button';

import { AvatarComponent } from '../../components/avatar/avatar.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { UsersService } from '../../services/users/users.service';
import { getMissingFields, hasValidEmail, RequirementsService } from '../../services/requirements/requirements.service';
import { InvitesService } from '../../services/invites/invites.service';
import { FooterComponent } from "../../components/footer/footer.component";
import { NavbarComponent } from "../../components/navbar/navbar.component";
import { MatTooltipModule } from '@angular/material/tooltip';
import { Invite } from '../../services/invites/invites.model';
import { Page } from '../../services/@shared.model';
import { User } from '../../services/users/users.model';
import { Enrollment } from '../../services/enrollments/enrollments.model';

@Component({
    selector: 'app-accept-invite',
    templateUrl: './accept-invite.component.html',
    styleUrls: ['./accept-invite.component.scss'],
    imports: [AvatarComponent, MatButtonModule, MatTooltipModule, FaIconComponent, MatPaginatorModule, FooterComponent, NavbarComponent]
})
export class AcceptInviteComponent {

  readonly $route = inject(ActivatedRoute);
  readonly $router = inject(Router);
  readonly $invites = inject(InvitesService);
  readonly $requirements = inject(RequirementsService);
  readonly $users = inject(UsersService);

  inviteCode = toSignal(
    this.$route.params.pipe(map(params => params['inviteCode']))
  );
  page = toSignal(
    this.$route.queryParams.pipe(map(params => params['page']))
  ) ;

  user = resource({
    params: () => ({}),
    loader: (() => this.$users.getUser(false))
  });

  invite = resource({
    params: () => {
      return {inviteCode: this.inviteCode()};
    },
    loader: ({params}) => {
      return firstValueFrom(this.$invites.getInvite(params.inviteCode))
    }
  });

  acceptance: ResourceRef<Enrollment|null|undefined> = resource({
    params: () => ({inviteCode: this.inviteCode(), user: this.user.value()}),
    loader: ({params}) => {
      console.log(params)
      if (!params.user) {
        return new Promise((resolve,reject)=> resolve(null));
      }
      return firstValueFrom(this.$invites.getMyAcceptance(params.inviteCode))
    }
  });

  acceptees: ResourceRef<Page<User>|null|undefined> = resource({
    params: () => ({inviteCode: this.inviteCode(), page:this.page(), acceptance: this.acceptance.value() }),
    loader: ({params}) => {
      if (!params.acceptance) {
        return new Promise((resolve,reject)=> resolve(null));
      }
      return firstValueFrom(this.$invites.getAcceptances(params.inviteCode, params.page))
    }
  });
  
  public setPage(page:number) {
    this.$router.navigate(
      [], 
      {
        relativeTo: this.$route,
        queryParams: { page },
        queryParamsHandling: 'merge'
      }
    );
  }

  selfieRequired = computed(() => {
    if (!this.invite.value())
      return false ;

    const requirements = this.invite.value()!.requirements;

    if (!requirements || !requirements.fields) {
      return false ;
    }

    return requirements.fields.includes('SELFIE');
  })


  hasInvalidEmail = computed(() =>{

    if (!this.user.value() || !this.invite.value())
      return false ;

    return !hasValidEmail(this.user.value()!, this.invite.value()!.requirements);
  })

  missingProfileFields = computed(() => {
     if (!this.user.value() || !this.invite.value())
      return [];

    return getMissingFields(this.user.value()!, this.invite.value()!.requirements);
  })
  
  get accepted(): boolean {
    return !!this.acceptance ;
  }

  signIn() {
    this.$router.navigate([`signin`], { queryParams: {returnUrl: '/invite/' + this.inviteCode()}});
  }

  editProfile() {
    this.$router.navigate([`edit-profile`], { queryParams: {returnUrl: '/invite/' + this.inviteCode()}});
  }

  async accept() {

    if (!this.user || !this.invite) {
      return ;
    }

    if (this.hasInvalidEmail() || this.missingProfileFields().length > 0) {
      return ;
    }

    const acceptance = await firstValueFrom(this.$invites.acceptInvite(this.inviteCode())) ;
    this.acceptance.set(acceptance);

    //await this.loadAcceptees(0);
  }

  /*
  async loadAcceptees(page: number) {

    this.loadingAcceptees = true ;

    const results = await firstValueFrom(this.invites.getAcceptances(this.inviteCode!, page));

    console.log(results);
    this.acceptees = results ;

    this.loadingAcceptees = false ;
  }*/


}
